export const OG_IMAGE = 'ogImageRatio'
export const COVER_IMAGE = 'horizontalImageRatio'

export const WRAP_WIDTH = 768
export const WRAP_HEIGHT = 413

export const CROP_WIDTH = 680
export const CROP_HEIGHT = 357

export const OG_IMAGE_DISPLAY_WIDTH = 420
export const OG_IMAGE_DISPLAY_HEIGHT = 221
export const HORIZONTAL_COVER_IMAGE_DISPLAY_WIDTH = 680
export const HORIZONTAL_COVER_IMAGE_DISPLAY_HEIGHT = 357

export const OG_IMAGE_API_CROPPED_WIDTH = 1200
export const OG_IMAGE_API_CROPPED_HEIGHT = 630
export const COVER_IMAGE_API_CROPPED_WIDTH = 1560
export const COVER_IMAGE_API_CROPPED_HEIGHT = 820
